"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StatusIndicator = require("./StatusIndicator");
Object.keys(_StatusIndicator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StatusIndicator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StatusIndicator[key];
    }
  });
});